import { Col, Row } from "antd"
import cx from "clsx"
import { useTranslation } from "react-i18next"
import { Spinner, Text, Title } from ".."
import { localisedValue } from "../../../utils"
import styles from "./index.module.less"

export const AIInsights = ({ data, isFetching }) => {
  const { t } = useTranslation()
  return isFetching ? (
    <Spinner size="medium" fullPageSpinner />
  ) : data?.ai_insights && Object?.keys?.(data.ai_insights)?.length ? (
    <div>
      <Title level={5} className="mbe-0">
        {t("Call Quality")}
      </Title>
      <div className={cx(styles.ingightBarOuter, "pb-32")}>
        <div className={styles.insightBar}>
          <div
            className={styles.insightBarOverlay}
            style={{
              width: data?.ai_insights?.score + "%",
            }}
          ></div>
          <div
            className={styles.pin}
            style={{
              insetInlineStart: data?.ai_insights?.regional_average + "%",
            }}
          >
            <span>
              <strong className={data?.ai_insights?.regional_average > 30 ? styles.left : styles.right}>
                {t("Regional Average")}
              </strong>
              {data?.ai_insights?.regional_average}
            </span>
          </div>
          <div
            className={cx(styles.pin, styles.pinDown)}
            style={{
              insetInlineStart: data?.ai_insights?.score + "%",
            }}
          >
            <span>
              <strong className={data?.ai_insights?.score > 30 ? styles.left : styles.right}>{t("Your Score")}</strong>
              {data?.ai_insights?.score}
            </span>
          </div>
        </div>
      </div>

      {data?.scoreBreakdown?.length && (
        <Title level={5} style={{ marginTop: 20 }}>
          {t("Breakdown")}
        </Title>
      )}
      <Row gutter={24}>
        {data?.scoreBreakdown &&
          data?.scoreBreakdown?.map((item, index) => (
            <Col span={12}>
              <Row key={index}>
                <Col span={16}>
                  <Text type="secondary">{localisedValue({ object: item, key: "label" })}</Text>
                </Col>
                <Col span={8} align="end">
                  <strong style={{ fontSize: 18 }}>{item?.value}</strong>{" "}
                  {item?.totalValue && <Text type="secondaryLight"> / {item?.totalValue}</Text>}
                </Col>
              </Row>
            </Col>
          ))}
      </Row>
    </div>
  ) : null
}
